define('views/components/metrik_user/metrik_user',['require','backbone','text!templates/components/metrik_user/metrik_user.html'],function (require) {
  var Backbone = require("backbone");

  var temp = require("text!templates/components/metrik_user/metrik_user.html");
  return Backbone.Marionette.ItemView.extend({
    tagName: "tr",
    template: _.template(temp),
    className: "customer-product-item",

    initialize: function () {},

    ui: function () {
      return {
        trashButton: "#trash-button",
        notActive: "#not-activated",
      };
    },

    events: {
      "click @ui.trashButton": "trashButtonClicked",
      "click @ui.notActive": "notActiveClicked",
    },

    deleteUser: function (id) {},

    trashButtonClicked: function () {
      var _this = this;
      var email = _this.model.attributes.email;
      var collection = _this.model.collection;
      var user_email = App.user.get("email");

      if (email === user_email && App.user.get("customer")) {
        App.utils.showMessage(
          "warning",
          App.polyglot.t("metrik_user_undeletable")
        );
      } else if (App.user.get("is_staff") || App.user.get("customer")) {
        var parameters = _this.model.collection.parameters;

        if (parameters && parameters.customers__id)
          _this.model.set("customer_id", parameters.customers__id);

        App.utils.showConfirmModal(
          App.polyglot.t("metik_user_delete_message", { email: email }),
          function () {
            _this.model.destroy({
              success: function () {
                collection.fetch();
                App.utils.showMessage(
                  "success",
                  App.polyglot.t("metrik_user_delete_success")
                );
              },
              error: function () {
                App.utils.showMessage(
                  "error",
                  App.polyglot.t("metrik_user_delete_error")
                );
              },
              wait: true,
            });
          }
        );
      }
    },

    sendRequets: function (id) {
      var _this = this;

      $.ajax({
        url: App.Config.apiBase + "metrik-users/" + id + "/invite/",
        type: "POST",
        success: function () {
          App.utils.showMessage(
            "success",
            App.polyglot.t("metrik_user_invate_success")
          );
        },

        error: function (xhr, ajaxOptions, thrownError) {
          // Show error messages
          if (xhr.responseJSON && xhr.responseJSON.errors) {
            for (var i = 0; i < xhr.responseJSON.errors.length; i++) {
              App.utils.showMessage(
                "error",
                xhr.responseJSON.errors[i].message
              );
            }
          } else {
            App.utils.showMessage(
              "error",
              App.polyglot.t("metrik_user_invate_error")
            );
          }
        },
      });
    },

    notActiveClicked: function () {
      var _this = this;
      if( App.user.get("customer") || App.user.get("is_staff") ){
        App.utils.showConfirmModal(
          App.polyglot.t("metrik_user_invate_message", {
            email: _this.model.attributes.email,
          }),
          function () {
            _this.sendRequets(_this.model.id);
          }
        );
      }
    },
  });
});

